import React from "react";
import { useTranslation } from "react-i18next";

const CheckoutPage = () => {
  const { t } = useTranslation();

  return (
    <div className="px-5 md:px-20 lg:px-40 py-16 bg-gray-50 min-h-screen">
      <h1 className="text-3xl font-semibold text-green-800 mb-10">
        {t("checkout.title")}
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">

        {/* Left: Forms */}
        <div className="lg:col-span-2 space-y-8">

          {/* Address */}
          <div className="bg-fecos-surface p-6 rounded-xl shadow-sm border">
            <h2 className="text-xl font-semibold text-green-900 mb-4">
              {t("checkout.addressTitle")}
            </h2>

            <input
              type="text"
              placeholder={t("checkout.form.name")}
              className="w-full p-3 border rounded-lg mb-3"
            />

            <input
              type="text"
              placeholder={t("checkout.form.address")}
              className="w-full p-3 border rounded-lg mb-3"
            />

            <div className="grid grid-cols-2 gap-4">
              <input
                type="text"
                placeholder={t("checkout.form.city")}
                className="w-full p-3 border rounded-lg"
              />
              <input
                type="text"
                placeholder={t("checkout.form.district")}
                className="w-full p-3 border rounded-lg"
              />
            </div>
          </div>

          {/* Payment */}
          <div className="bg-fecos-surface p-6 rounded-xl shadow-sm border">
            <h2 className="text-xl font-semibold text-green-900 mb-4">
              {t("checkout.paymentTitle")}
            </h2>

            <input
              type="text"
              placeholder={t("checkout.form.cardName")}
              className="w-full p-3 border rounded-lg mb-3"
            />

            <input
              type="text"
              placeholder={t("checkout.form.cardNumber")}
              className="w-full p-3 border rounded-lg mb-3"
            />

            <div className="grid grid-cols-2 gap-4">
              <input
                type="text"
                placeholder={t("checkout.form.expiry")}
                className="w-full p-3 border rounded-lg"
              />
              <input
                type="text"
                placeholder={t("checkout.form.cvv")}
                className="w-full p-3 border rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* Right: Summary */}
        <div className="p-6 bg-fecos-surface rounded-xl shadow-sm border h-max">
          <h2 className="text-xl font-semibold text-green-900 mb-4">
            {t("cart.summary.title")}
          </h2>

          <div className="flex justify-between text-gray-700 mb-2">
            <span>{t("cart.summary.subtotal")}</span>
            <span>299 ₺</span>
          </div>

          <div className="flex justify-between text-gray-700 mb-2">
            <span>{t("cart.summary.shipping")}</span>
            <span>0 ₺</span>
          </div>

          <div className="border-t pt-4 flex justify-between text-lg font-bold text-green-900">
            <span>{t("cart.summary.total")}</span>
            <span>299 ₺</span>
          </div>

          <button className="w-full mt-8 bg-green-700 text-white py-3 rounded-xl hover:bg-green-800 transition">
            {t("checkout.complete")}
          </button>
        </div>

      </div>
    </div>
  );
};

export default CheckoutPage;
